import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';
import { CategoryQueryKeys } from './categoryQueryKeys';

export const useDeleteCategoryMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<ApiResponse<void>, Error, string>({
        mutationFn: (id) => apiClient.categories.deleteCategory(id),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: CategoryQueryKeys.all,
                });
            }
        },
    });
};
